import { QuerySwitch } from 'components/QuerySwitch';
import { DetailTabView } from 'pages/Settings/pages/LocationSettings/PositionsAllocation/RemovePositionModal/views/OpenShifts/DetailView/DetailTabView/DetailTabView';
import { FC } from 'react';
import { IDetailViewComponentProps } from 'pages/Settings/pages/LocationSettings/PositionsAllocation/RemovePositionModal/views/OpenShifts/DetailView/DetailView.types';
import { ShiftModalUrlDataProvider } from 'modals/ShiftModal/ShiftModalProvider.data.context';
import { ShiftModalDataContext } from 'modals/ShiftModal/ShiftModalDataContext';
import { useRemovePositionModalUIContext } from 'pages/Settings/pages/LocationSettings/PositionsAllocation/RemovePositionModal/RemovePositionModal.ui.context';

export const DetailViewComponent: FC<IDetailViewComponentProps> = (values) => {
  return <DetailTabView {...values} />;
};

export const DetailView: FC = () => {
  const { shift_id } = useRemovePositionModalUIContext();

  return (
    <ShiftModalUrlDataProvider shiftId={shift_id as unknown as string | undefined}>
      <QuerySwitch component={DetailViewComponent} context={ShiftModalDataContext} />
    </ShiftModalUrlDataProvider>
  );
};
